import { CircularProgress, Box, Typography } from '@mui/material';

export default function FullscreenLoader({ text = 'Loading...' }) {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        bgcolor: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <CircularProgress size={80} thickness={5} color="primary" />
      {text && <Typography variant="h6">{text}</Typography>}
    </Box>
  );
}